import React from "react";
import Button from "react-bootstrap/Button";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Styled component for custom icon button
const StyledIconButton = styled(Button)`
  padding: 8px;
  border-radius: 50%;
  min-width: 40px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${(props) => props.theme.hoverBg};
    cursor: pointer;
  }

  &:focus {
    box-shadow: none;
  }

  // Size variations
  ${(props) =>
    props.size === "small" &&
    `
    padding: 4px;
    min-width: 24px;
    min-height: 24px;
  `}

  ${(props) =>
    props.size === "large" &&
    `
    padding: 12px;
    min-width: 48px;
    min-height: 48px;
  `}
`;

const BootIconButton = ({
  icon,
  color = "",
  size = "medium",
  onClick,
  ariaLabel,
  children,
  ...props
}) => {
  return (
    <StyledIconButton
      variant={color}
      size={size}
      onClick={onClick}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </StyledIconButton>
  );
};

export default BootIconButton;
